export const PitchButtons = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-row border rounded-lg border-white/10 bg-white/10 backdrop-blur-lg py-2.5 p-2 gap-x-2 w-fit text-secondary-dark">
    {children}
  </div>
);
